import { diContainer, serviceNames } from '../diContainer/diContainer';
import ShippingUIState from '../stores/UIState/ShippingUIState';
import AnalyticsRepository from '../repositories/AnalyticsRepository';
import TransactionRepository from '../repositories/TransactionRepository';

export default class SetShippingMethodUseCase {
  private shippingMethodId: number;

  private analyticsRepository: AnalyticsRepository;

  private transactionRepository: TransactionRepository;

  private shippingUIState: ShippingUIState;

  constructor(shippingMethodId: number) {
    this.shippingMethodId = shippingMethodId;
    this.analyticsRepository = diContainer.get(serviceNames.analyticsRepository);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.shippingUIState = diContainer.get(serviceNames.shippingUIState);
  }

  execute = async (): Promise<void> => {
    try {
      this.shippingUIState.updateContinueLoadingButtonState(true);
      const transaction = await this.transactionRepository.getTransaction();
      const selectedShippingMethod = transaction.getShippingMethodById(this.shippingMethodId);
      await this.transactionRepository.setShippingMethod(selectedShippingMethod.id, true);

      const shipMethod = transaction.shippingMethods?.getItemById(this.shippingMethodId);
      const shipMethodName = shipMethod ? shipMethod.name : '';
      this.analyticsRepository.selectShippingOptionLinkEvent(shipMethodName);
    } finally {
      this.shippingUIState.updateContinueLoadingButtonState(false);
    }
  };
}
